
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/notification",
      function () {
        return require("private-next-pages/settings/notification.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/notification"])
      });
    }
  